module.exports = __webpack_public_path__ + "static/media/OnGoru.76dd6561.png";